<script setup lang="ts">
import { toRefs } from '@vueuse/core'

interface Props {
  time: Date
}

const props = defineProps<Props>()
const { time } = toRefs(props)
const { days, hours, minutes, seconds, isReached } = useCountdown(time)
</script>

<template>
  <div
    v-if="!isReached"
    class="next-game-countdown"
  >
    <div class="next-game-countdown__timer">
      <div class="next-game-countdown__item">
        <strong class="next-game-countdown__item-time">{{ days }}</strong>
        <span class="next-game-countdown__item-label">Days</span>
      </div>
      <div class="next-game-countdown__item">
        <strong class="next-game-countdown__item-time">{{ hours }}</strong>
        <span class="next-game-countdown__item-label">Hours</span>
      </div>
      <div class="next-game-countdown__item">
        <strong class="next-game-countdown__item-time">{{ minutes }}</strong>
        <span class="next-game-countdown__item-label">Mins</span>
      </div>
      <div class="next-game-countdown__item">
        <strong class="next-game-countdown__item-time">{{ seconds }}</strong>
        <span class="next-game-countdown__item-label">Secs</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.next-game-countdown {
  &__timer {
    @apply gap-[10px] flex items-center;
    @apply xl:justify-end;
  }

  &__item {
    @apply w-[64px] h-[62px] flex flex-col items-center justify-center gap-[5px] border border-primary/20;

    &-time {
      @apply text-[18px] text-primary font-medium leading-[1];
    }

    &-label {
      @apply text-[16px] text-primary/60 leading-[1];
    }
  }
}
</style>
